import { gql } from '@apollo/client';

export const CLAIM_ADMIN_TOKEN = gql`
  mutation claimAdminToken($tokenId: String!) {
    AdminMutations {
      claimAdminToken(tokenId: $tokenId) {
        message
      }
    }
  }
`;
